// extracted by mini-css-extract-plugin
export default {"root":"ViewToggle_root__mpzgA"};